import ExpandWrapperTransition from '@/components/transitions/expand-wrapper'
import ExpandTransition from '@/components/transitions/expand'
import SlideTransition from '@/components/transitions/slide'
import SlideListTransition from '@/components/transitions/slide-list.vue'
export default {
  install (Vue, options) {
    Vue.component(ExpandTransition.name, ExpandTransition)
    Vue.component(ExpandWrapperTransition.name, ExpandWrapperTransition)
    Vue.component(SlideTransition.name, SlideTransition)
    Vue.component(SlideListTransition.name, SlideListTransition)
  }
}
